export default __webpack_public_path__ + "static/media/b2.59722096.png";